<template>
    <Teleport to="body">
        <div v-if="internalOpen" class="dialog-overlay" @click.self="closeDialog">
            <v-card
                :width="width"
                :max-width="maxWidth"
                class="dialog-card"
                :ripple="false"
                @click.stop
                :style="{ overflowY: 'auto', overflowX: 'hidden', maxHeight: '84vh' }"
            >
                <Form
                    ref="observer"
                    v-slot="{ meta }"
                    validate-on-mount
                >
                    <v-form @submit.prevent="handleSubmit">
                        <v-card-title style="display: flex; align-items: center; padding-top: 15px;">
                            <h2 style="font-weight: bold; flex: 1; text-align: center; margin-left: 40px;">{{ title }}</h2>
                            <v-icon @click="closeDialog" color="accent" style="cursor: pointer;">mdi-close</v-icon>
                        </v-card-title>
                        <v-card-text class="text--text">
                            <v-container>
                                <slot name="form-content"></slot>
                            </v-container>
                        </v-card-text>
                        <v-card-actions>
                            <v-spacer></v-spacer>
                            <app-btn
                                :color="!meta.valid ? '#757575' : 'primary'"
                                type="submit"
                                class="mb-4"
                                :disabled="!meta.valid"
                                :loading="saving"
                            >
                                {{ submitButtonTitle }}
                            </app-btn>
                            <v-spacer></v-spacer>
                        </v-card-actions>
                    </v-form>
                </Form>
            </v-card>
        </div>
    </Teleport>
</template>

<script>
import { Field, Form, defineRule, configure } from 'vee-validate'

export default {
    props: {
        open: {
            required: true,
            type: Boolean
        },
        title: {
            required: true,
            type: String
        },
        width: {
            required: false,
            type: [Number, String],
            default: 500
        },
        maxWidth: {
            required: false,
            type: [Number, String],
        },
        submitButtonTitle: {
            type: String,
            default: 'Save'
        },
        saving: {
            type: Boolean
        },
        maxEventEndDate: {
            type: String,
        },
    },
    name: "DialogForm",
    emits: ['close', 'submit', 'createReport'],
    components: {
        Form
    },
    data() {
        return {
            lastName: '',
            internalOpen: false
        }
    },
    watch: {
        open: {
            immediate: true,
            handler(newValue) {
                this.internalOpen = newValue
            }
        },
        internalOpen(newValue) {
            if (!newValue && this.open) {
                this.$emit('close')
            }
        }
    },
    methods: {
        handleSubmit() {
            this.$emit('submit');
            // this.closeDialog()
        },
        closeDialog() {
            this.$emit('close')
        }
    }
}
</script>

<style scoped>
.dialog-overlay {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.4);
    backdrop-filter: blur(4px);
    display: flex;
    align-items: flex-start;
    justify-content: center;
    padding-top: 8vh;
    z-index: 2000;
}

.dialog-card {
    overflow-y: auto;
    overflow-x: hidden;
    max-height: 84vh;
    border-top: 4px solid #33D3FF;
    border-radius: 16px !important;
    background-color: white;
    box-shadow: 0 8px 24px rgba(0, 0, 0, 0.12);
}
</style>